export default {
  errorFetching: false,
  loading: false,
  campaigns: null,
  selectedCampaign: null,
  campaignSelectedByUser: false,
  selectedCategory: null,
  altitude: null,
  head: 0,
  headFrom: '',
  latLng: null,
  name: '',
  date: '',
  pan: null,
  pitch: null,
  roll: null,
  anlgeWidth: null,
  anlgeHeight: null,
  anlgeHeightOffset: null,
  laterals: null,
  neighbours: null,
  history: null,
  metadataMethods: ['Avió', 'Helicòpter', 'Dron', 'Mobile Mapping', 'Estàtic', 'Altres'],
  selectedLateral: null,
  folderPanoramaCampaign: null,
  folderLateralsCampaign: null,
  folderPointCloudCampaign: null,
  folderPanorama: null,
  folderPointCloud: null,
  screenshot: null,
  srcPannellum: null,
  srcLateral: null,
  srcPotree: null,
  showPannellum: true,
  showLateral: false,
  showPotree: true,
  splitterActivatedByUser: false,
  result: null,
  currentPointclouds: [],
  showDrawingNavigationWindow: false
}
